module.exports = {
    //socketUrl: "https://localhost:2083",
    //url: "http://localhost/gallery/public/api",
    //url: "http://178.154.211.58/gallery-api/public/api",
    //url: "https://api.starykh.gallery/gallery-api/public/api",
    url: "https://api.starykhgallery.ru/gallery-api/public/api",
}
